import slider from '../components/slider.js'
import accordion from '../components/accordion.js'
import showDates from '../components/event-page-dates.js'

const body = {
    settings: {
        sliderClass: '.splide',
        accordionClass: '.accordion-component',
        datesClass: '.event-info-panel__block-inner',
    },
    init: function() {
        const settings = this.settings
        if(document.querySelectorAll(settings.sliderClass)){
            slider(settings.sliderClass)
        }
        if(document.querySelectorAll(settings.accordionClass)) {
            accordion(settings.accordionClass)
        }
        if(document.querySelectorAll(settings.datesClass)) {
            showDates(settings.datesClass)
        }
    }
}

export default body